import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mockArticles } from '@/mocks/articles';

interface Props {
  currentSlug: string;
}

export default function RelatedArticles({ currentSlug }: Props) {
  const { t } = useTranslation();
  const related = mockArticles
    .filter((a) => a.slug !== currentSlug)
    .slice(0, 4);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            {t('article_relatedCta_title')}
          </h2>
          <p className="text-sm text-foreground-600 mt-2">{t('article_relatedCta_subtitle')}</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-7 py-3 mt-6 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('article_relatedCta_button')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {related.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.03] cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden rounded-xl">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <h3 className="text-xs md:text-sm font-medium text-background-50 line-clamp-2">
                    {article.title}
                  </h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}